(() => {
  const selector = '[data-culge-faux-hero]';

  function init(section) {
    if (!section || section.dataset.cfhReady === 'true') return;
    section.dataset.cfhReady = 'true';

    if (!section.classList.contains('cfh--reveal')) {
      section.classList.add('cfh--visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('cfh--visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cfh--visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    observer.observe(section);
  }

  function initAll(root = document) {
    if (root.matches && root.matches(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
